exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-bar__progress-played__3a623{color:-wix-colors-buttonsAndLinksColor}", ""]);

// exports
exports.locals = {
	"progress-played": "progress-bar__progress-played__3a623",
	"progressPlayed": "progress-bar__progress-played__3a623"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"sourceMap":false,"importLoaders":1,"camelCase":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./~/stylus-loader?{"sourceMap":true,"resolve":true,"define":{}}!./src/widget/player-widget/components/new-player/components/progress-bar.styl
// module id = 1640
// module chunks = 1 2 3